<template>
  <span class="tooltip-container">
    <slot></slot>
    <span class="tooltip">{{title}}</span>
  </span>
</template>

<script>
export default {
  name: 'tooltip',
  props: {
    title: String
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tooltip-container {
  position: relative;
  text-align: center;
  display: inline-block;
  &:hover {
    .tooltip {
      display: inline-block;
    }
  }
}
.tooltip {
  display: none;
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  height: 24px;
  color: #fff;
  top: -40px;
  transform: translateX(30%);
  font-size: 12px;
  line-height: 24px;
  white-space: nowrap;
  left: 50%;
  transform: translate(-50%, 0px);
  padding: 0 5px;
  &:before{
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border: transparent 5px solid;
    border-top-color: rgba(0, 0, 0, 0.6);
    bottom: -10px;
    left: 50%;
    z-index: -1;
    transform: translate(-50%, 0);
  }
}
</style>
